import MessageConfigurationView from "../messageConfiguration/messageConfigurationView";
import MessageConfigurationDetail from "../messageConfiguration/messageConfigurationDetail";
import { getMessageMasterById } from "../../../services/graphql/queries/messageConfiguration";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import { connect } from "react-redux";
import { SET_TIMEOUT_VALUE } from "../../../constants/app-constants";
import { getAccessPermisionQuery } from "../../../services/graphql/queries/accessPermission";
import React from "react";
import queryString from "query-string";
class MessageConfigurationProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      message: "",
      accessSpecifier: {},
      Message_Configuration_Sms_Feature_ID: 175,
      Message_Configuration_Email_Feature_ID: 176,
      Message_Configuration_App_Feature_ID: 177,
      Message_Configuration_Module_ID: 6
    };
    this.fetchData = this.fetchData.bind(this);
    this.fetchAccessSpecifier = this.fetchAccessSpecifier.bind(this);
  }
  fetchData() {
    this.props.client
      .query({
        query: getMessageMasterById,
        variables: {
          id: parseInt(queryString.parse(this.props.location.search).id)
        },

        fetchPolicy: "network-only"
      })
      .then(result => {
        const message = result.data.getMessageMasterById;
        this.setState({ message: message });
      })
      .catch(error => {
        this.setState({
          loading: false,
          error: error.message,
          accessSpecifierLoading: false
        });
      });
    // .catch(error => {
    //   error.graphQLErrors.map(({ message }, i) => {
    //     this.setState(prevState => {
    //       return { errors: [message] };
    //     });
    //   });
    //   setTimeout(() => {
    //     this.setState({ errors: [] });
    //   }, SET_TIMEOUT_VALUE);
    // });
  }
  fetchAccessSpecifier() {
    this.props.client
      .query({
        query: getAccessPermisionQuery,
        variables: {
          moduleId: this.state.Message_Configuration_Module_ID
        },
        fetchPolicy: "network-only"
      })
      .then(result => {
        let response = result.data.getFunctionByModuleId;
        response = JSON.parse(response);
        if (Object.keys(response).length != 0) {
          this.setState(
            {
              accessSpecifier: response
            },
            () => {
              this.fetchData();
            }
          );
        }
      })
      .catch(error => {
        this.setState({
          loading: false,
          error: error.message
        });
      });
  }
  componentDidMount() {
    this.fetchAccessSpecifier();
  }
  render() {
    const {
      message,
      accessSpecifier,
      Message_Configuration_Sms_Feature_ID,
      Message_Configuration_Email_Feature_ID,
      Message_Configuration_App_Feature_ID
    } = this.state;
    return (
      <>
        {this.state.message != "" &&
        Object.keys(this.state.accessSpecifier).length ? (
          <>
            <MessageConfigurationView message={message} />
            {(accessSpecifier[Message_Configuration_Sms_Feature_ID] &&
              accessSpecifier[Message_Configuration_Sms_Feature_ID].viewP &&
              message.bySMS) ||
            (accessSpecifier[Message_Configuration_Email_Feature_ID] &&
              accessSpecifier[Message_Configuration_Email_Feature_ID].viewP &&
              message.byEMAIL) ||
            (accessSpecifier[Message_Configuration_App_Feature_ID] &&
              accessSpecifier[Message_Configuration_App_Feature_ID].viewP &&
              message.byAPP) ? (
              <MessageConfigurationDetail
                message={message}
                accessSpecifier={accessSpecifier}
              />
            ) : null}
          </>
        ) : (
          <div>Fetching...</div>
        )}
      </>
    );
  }
}

export default withRouter(connect()(withApollo(MessageConfigurationProfile)));
